export enum AssetNoteStates {
  EMPTY_NOTE,
  EDIT_NOTE,
  HAS_NOTE,
}
